import React, {useEffect, useRef} from "react";
import OdxRailnavigation from "../NativeOdx/Odx-Railnavigation";
import {IContent} from "../../HubFramework";
import {IModulePage} from "../../HubFramework/IHub";
import {transformOdxLayoutRef} from "../odxLayoutRef";

interface OdxMainLayoutProps extends React.HTMLProps<HTMLDivElement> {
    hubContent: IContent;
    outlet: React.ReactNode;
    currentPage: IModulePage;
    className?: string;
}

const MainLayout = ({hubContent, outlet, className, currentPage, ...rest}: OdxMainLayoutProps) => {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        transformOdxLayoutRef(containerRef.current);
    }, []);

    return (
        <div ref={containerRef}  {...rest}>
            <div data-odxlayout="grid" className={`${className} !gap-0`}>
                <div data-odxlayout="1@tablet 2@mobile" className={`${className} w-[230px]`}>
                    <OdxRailnavigation variant={"default"}
                                       navigationItems={hubContent.pages}
                                       currentPage={currentPage}
                    />
                </div>
                <div data-odxlayout=" 11@tablet separator 10@mobile" className={`${className} `}>
                    <div data-odxlayout="12" className={"odx-app-page__content h-full"} data-scrollable>
                        {outlet}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MainLayout;
